import { useState, useEffect } from "react"
import "../styles/LinkedList.css"
import Header from "./Header"
import BasicLinkedList from "./BasicLinkedList"
import SinglyLinkedList from "./SinglyLinkedList"
import DoublyLinkedList from "./DoublyLinkedList"
import CircularLinkedList from "./CircularLinkedList"
import InfoPanel from "./InfoPanel"
import OperationLogs from "./OperationLogs"

function LinkedList() {
  const [activeTab, setActiveTab] = useState("basic")
  const [logs, setLogs] = useState([])

  const addLog = (message, type = "info") => {
    setLogs((prevLogs) => [{ message, type, timestamp: new Date().toLocaleTimeString() }, ...prevLogs])
  }

  const clearLogs = () => {
    setLogs([])
  }

  return (
    <div style={{ background: '#0d1b2a', minHeight: '100vh', width: '100%' }}>
    <div className="llapp-container">
      <Header />

      <div className="llcontrol-panel">
        <div className="lltabs">
          <button className={`lltab ${activeTab === "basic" ? "active" : ""}`} onClick={() => setActiveTab("basic")}>
            Basic Linked List
          </button>
          <button className={`lltab ${activeTab === "singly" ? "active" : ""}`} onClick={() => setActiveTab("singly")}>
            Singly Linked List
          </button>
          <button className={`lltab ${activeTab === "doubly" ? "active" : ""}`} onClick={() => setActiveTab("doubly")}>
            Doubly Linked List
          </button>
          <button
            className={`lltab ${activeTab === "circular" ? "active" : ""}`}
            onClick={() => setActiveTab("circular")}
          >
            Circular Linked List
          </button>
        </div>
      </div>

      <div className="llmain-content">
        <div className="llvisualization-container">
          {activeTab === "basic" && <BasicLinkedList addLog={addLog} />}
          {activeTab === "singly" && <SinglyLinkedList addLog={addLog} />}
          {activeTab === "doubly" && <DoublyLinkedList addLog={addLog} />}
          {activeTab === "circular" && <CircularLinkedList addLog={addLog} />}
        </div>

        <div className="llside-panel">
          <InfoPanel type={activeTab} />
          <OperationLogs logs={logs} clearLogs={clearLogs} />
        </div>
      </div>
    </div>
    </div>
  )
}

export default LinkedList
